import apiV2 from './api-v2';

// Staged clusters (ZTP) moved from core's v1 /api/v1/staged-clusters to
// fleet's v2 /api/v2/staged-clusters — fleet now owns the feature end to end
// (records, ZTP state machine, config delivery), not just node selection.
// Proto field_name becomes fieldName over JSON transcoding (standard
// protobuf JSON mapping), matching fleet.js's other v2 clients.

const get = async () => {
    const client = await apiV2.getClient();
    const response = await client.get('/staged-clusters');
    const { data } = await apiV2.handleSuccess(response);
    return { data: { stagedClusters: data?.items || [] } };
};

const getById = async (id) => {
    const client = await apiV2.getClient();
    const response = await client.get(`/staged-clusters/${id}`);
    const { data } = await apiV2.handleSuccess(response);
    return { data: { stagedCluster: data?.stagedCluster || null } };
};

const create = async ({ payload }) => {
    const client = await apiV2.getClient();
    const response = await client.post('/staged-clusters', payload);
    const { data } = await apiV2.handleSuccess(response);
    return { data: data?.stagedCluster || null };
};

const removeById = async (id) => {
    const client = await apiV2.getClient();
    const response = await client.delete(`/staged-clusters/${id}`);
    return apiV2.handleSuccess(response);
};

const update = async (id, { payload }) => {
    const client = await apiV2.getClient();
    const response = await client.patch(`/staged-clusters/${id}`, payload);
    const { data } = await apiV2.handleSuccess(response);
    return { data: data?.stagedCluster || null };
};

const resendClusterConfig = async (id) => {
    const client = await apiV2.getClient();
    const response = await client.post(`/staged-clusters/${id}/resend-config`, {});
    const { data } = await apiV2.handleSuccess(response);
    return { data: data?.stagedCluster || null };
};

export default {
    get,
    getById,
    create,
    removeById,
    update,
    resendClusterConfig,
};
